import * as actionTypes from '../constants/fbAuthConstants';

export const fbAuthReducer = ( state = { token: {} },action) => {

    switch (action.type){
            case actionTypes.FB_AUTH_REQUESTS_SUCCESS:
                return {
                    loading: false,
                    token: action.payload
                };
            case actionTypes.FB_AUTH_REQUESTS_FAIL:
                 return {
                    loading: false,
                     error: action.payload
                };
                 default:
                 return state;
    }
};